/**
 * Created by Ning Jiang on 2022-08-23.
 */

import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {GameIntroViewConfig} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class SerialIntroPlugin extends NolimitGameIntroPlugin {

    private _config:GameIntroViewConfig;

    constructor(config:GameIntroViewConfig) {
        super(config);

        config.onResize = () => {
            if(this._view?.soundSetting) {
                this._view.soundSetting.position.set(NolimitApplication.screenBounds.left + 20, 675);
            }
        };

        this._config = config;
    }

    public async getReady():Promise<NolimitPlugin> {
        if(!SlotGame.apiPlugin.gameClientConfiguration.boostedBetAllowed) {
            this._config.pages.splice(1, 1);
        }
        return super.getReady();
    }
}